import React from 'react';
import { IIconProps } from './utils';

export const Time = ({
  fill = 'currentColor', height = 21, width = 21, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d={`M14.9999 8.75049V14.7416C14.9999 14.9074 15.0658 15.0663 15.183
          15.1835L17.4999 17.5005M14.9999 27.5005C8.09638 27.5005 2.49994 21.904 2.49994
          15.0005C2.49994 8.09693 8.09638 2.50049 14.9999 2.50049C21.9035 2.50049
          27.4999 8.09693 27.4999 15.0005C27.4999 21.904 21.9035 27.5005 14.9999 27.5005Z`}
      stroke={fill}
      strokeLinecap="round"
      strokeWidth="2.5"
    />
  </svg>
);
